import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { useLang } from "@/common/Contexts/LanguageContext";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { If } from "@componentsShared/Conditional/If";
import useIsMobile from "@hooks/useIsMobile";
import { useMatch } from "react-router-dom";
var BrandInfo = function BrandInfo(_ref) {
  var title = _ref.title;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSearchResultsData = useSearchResultsData(),
    seoAboutData = _useSearchResultsData.seoAboutData;
  var makeData = seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.makeData;
  var modelData = seoAboutData === null || seoAboutData === void 0 ? void 0 : seoAboutData.modelData;
  var lang = useLang();
  var isMobile = useIsMobile();
  var isMakeModelRouteAr = useMatch("/autos/:make/:model");
  var isMakeModelRouteEn = useMatch("/en/autos/:make/:model");
  // Check if we're on a model page
  var isModelPage = !!isMakeModelRouteAr || !!isMakeModelRouteEn;
  var cardItems = [{
    id: 1,
    key: tShort("brand/card_county", {
      ns: "web_search"
    }),
    value: lang === 'ar' ? makeData === null || makeData === void 0 ? void 0 : makeData.country_ar : makeData === null || makeData === void 0 ? void 0 : makeData.country_en,
    iconName: "material-symbols--garage-home-outline-rounded"
  }, {
    id: 2,
    key: isModelPage ? tShort("brand/card_production_year", {
      ns: "web_search"
    }) : tShort("brand/card_year", {
      ns: "web_search"
    }),
    value: isModelPage ? modelData === null || modelData === void 0 ? void 0 : modelData.date_range : makeData === null || makeData === void 0 ? void 0 : makeData.founded,
    iconName: "material-symbols--event-outline-rounded"
  }, {
    id: 3,
    key: isModelPage ? tShort("brand/structure_type", {
      ns: "web_search"
    }) : tShort("brand/card_headquarter", {
      ns: "web_search"
    }),
    value: isModelPage ? lang === 'ar' ? modelData === null || modelData === void 0 ? void 0 : modelData.car_shape_ar : modelData === null || modelData === void 0 ? void 0 : modelData.car_shape_en : lang === 'ar' ? makeData === null || makeData === void 0 ? void 0 : makeData.headquarters_ar : makeData === null || makeData === void 0 ? void 0 : makeData.headquarters_en,
    iconName: isModelPage ? "material-symbols--car-gear-outline-rounded" : "material-symbols--language"
  }, {
    id: 4,
    key: tShort("brand/card_agent", {
      ns: "web_search"
    }),
    value: lang === 'ar' ? makeData === null || makeData === void 0 ? void 0 : makeData.dealer_in_saudi_arabia_ar : makeData === null || makeData === void 0 ? void 0 : makeData.dealer_in_saudi_arabia_en,
    iconName: "material-symbols--location-on-outline-rounded"
  }, {
    id: 5,
    key: tShort("brand/card_founder", {
      ns: "web_search"
    }),
    value: lang === 'ar' ? makeData === null || makeData === void 0 ? void 0 : makeData.founder_ar : makeData === null || makeData === void 0 ? void 0 : makeData.founder_en,
    iconName: "material-symbols--person-2-outline"
  }];
  var renderItem = function renderItem(iconName, key, value) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1 items-center md:gap-2"
    }, /*#__PURE__*/React.createElement(Conditional, {
      condition: isMobile
    }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Icon, {
      icon: iconName,
      className: "shrink-0"
    })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Icon, {
      icon: iconName,
      className: "shrink-0",
      width: 6,
      height: 6
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-0.5 items-center flex-wrap"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-gray-text text-xs md:text-base"
    }, key), /*#__PURE__*/React.createElement("p", {
      className: "font-medium text-gray-text text-xs md:text-base"
    }, value))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:gap-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-start text-primary-old text-base font-bold leading-8 md:text-2xl"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "relative bg-white rounded-lg shadow-[0px_0px_5px_0px_rgba(60,86,212,0.40)] overflow-hidden flex flex-col gap-5 px-2 pt-1.5 pb-5 md:flex-row md:gap-[50px] md:py-3 md:px-4 md:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full py-11 px-14 rounded bg-[#F2F5F8] flex items-center justify-center md:w-[370px] md:min-h-[230px] md:py-6 md:px-0 md:items-baseline md:rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 justify-center items-center md:gap-[60px]"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-center font-bold text-base text-primary-old md:text-2xl"
  }, tShort("brand/card_image_title", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(makeData !== null && makeData !== void 0 && makeData.image_path)
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-[87px] h-[50px]",
    alt: lang === 'ar' ? makeData === null || makeData === void 0 ? void 0 : makeData.name_ar : makeData === null || makeData === void 0 ? void 0 : makeData.name_en,
    src: makeData === null || makeData === void 0 ? void 0 : makeData.image_path
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 px-3 md:gap-7 md:pt-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-bold text-base text-primary-old leading-8 md:text-2xl"
  }, tShort("brand/card_title", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-x-4 gap-y-3"
  }, cardItems.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderItem(item.iconName, item.key, item.value));
  }))))));
};
export default BrandInfo;